module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style11/message-alert-style11.component.scss
// module id = ./src/app/features/message-alert/message-alert-style11/message-alert-style11.component.scss
// module chunks = main